import React from "react";
import {Link} from "react-router";
import Icon from "../Icon";
import svgSortAsc from "../../svgs/arrow-up.svg";
import svgSortDesc from "../../svgs/arrow-down.svg";
import Checkbox from "../CheckboxNew";

function buildQuery({query, orders, parts, elCode}) {
    const q = {...query};
    let isActive = false;
    let directionSort = "";

    q.order = [...orders];

    const hadOrder = parts.some(([code, direction], i) => {
        if (code === elCode) {
            isActive = true;

            if (direction === "asc") {
                q.order[i] = elCode + ".desc";
                directionSort = "asc";
            } else {
                q.order.splice(i, 1);
                directionSort = "desc";
            }

            return true;
        }
    });

    if (!hadOrder) {
        q.order.push(elCode + ".asc");
    }

    return {q, isActive, directionSort};
}

export default class extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            displayDiv: false,
        }
    }

    componentDidMount() {
        setTimeout(() => {
            this.setState({displayDiv: true});
        }, 1000);
    }

    render() {
        const {columns, items, query, classNameModifier, toggleCheckbox, hasSubColumns} = this.props;
        const displayDiv = this.state.displayDiv;
        const orders = query && query.order
            ? Array.isArray(query.order)
                ? query.order
                : [query.order]
            : [];
        const parts = orders.map((x) => x.split("."));

        return (
            <React.Fragment>
                <div className={`SortTable_rounded-corner ${classNameModifier ? classNameModifier : ''}${displayDiv ? '' : ' display-none'}`}/>
                <table className={"SortTable" + (classNameModifier ? " SortTable--" + classNameModifier : "")}>
                    <thead>
                    <tr>
                        {columns.map((el, i) => {
                            if (el.code) {
                                const {q, isActive, directionSort} = buildQuery({query, orders, parts, elCode: el.code});
                                return (
                                    <th className={`${isActive ? "SortTable_th--active" : ""} padding-left padding-right`}
                                        key={i}
                                        style={el.columnStyle}>
                                        <Link to={{pathname: document.location.pathname, query: q}}>
                                            <div
                                                className={`SortTable_th_name ${directionSort === "asc" || directionSort === "desc" ? "active" : ""}`}>
                                                <span
                                                    className={`SortTable_th_name_icon top ${directionSort === "asc" ? "active" : ""}`}>
                                                    <Icon svg={svgSortAsc}/>
                                                </span>
                                                {el.name}
                                                <span
                                                    className={`SortTable_th_name_icon bottom ${directionSort === "desc" ? "active" : ""}`}>
                                                    <Icon svg={svgSortDesc}/>
                                                </span>
                                            </div>
                                        </Link>
                                    </th>
                                );
                            } else {
                                return (
                                    <th key={i} className={el.subColumns ? '' : 'padding-left padding-right'}
                                        style={el.columnStyle}>
                                        <div className='th' style={el.headerStyle}>
                                            {el.name}
                                        </div>
                                        {hasSubColumns && el.subColumns &&
                                        <div className='SortTable_subcols'>
                                            {el.subColumns.map((subEl, j) => {
                                                if (subEl.code) {
                                                    const {q, isActive, directionSort} = buildQuery({
                                                        query,
                                                        orders,
                                                        parts,
                                                        elCode: subEl.code
                                                    });
                                                    return (
                                                        <React.Fragment key={`${i}-${j}`}>
                                                            <Link to={{pathname: document.location.pathname, query: q}}
                                                                  className={`${isActive ? "SortTable_th--active" : ""}`}
                                                                  key={`${i}-${j}`}
                                                                  style={subEl.headerStyle}>
                                                                <div
                                                                    className={`SortTable_th_name ${directionSort === "asc" || directionSort === "desc" ? "active" : ""}`}>
                                                                        <span
                                                                            className={`SortTable_th_name_icon top ${directionSort === "asc" ? "active" : ""}`}>
                                                                            <Icon svg={svgSortAsc}/>
                                                                        </span>
                                                                    {subEl.name}
                                                                    <span
                                                                        className={`SortTable_th_name_icon bottom ${directionSort === "desc" ? "active" : ""}`}>
                                                                            <Icon svg={svgSortDesc}/>
                                                                        </span>
                                                                </div>
                                                            </Link>
                                                            {j !== el.subColumns.length - 1 &&
                                                            <div className="border-right"/>}
                                                        </React.Fragment>
                                                    );
                                                }
                                            })}
                                        </div>
                                        }
                                    </th>
                                );
                            }
                        })}
                    </tr>
                    </thead>
                    <tbody>
                    {items ?
                        items.map((el, index) => {
                            return (
                                <tr key={el.ARCIMEDES_ROW_ID || index}>
                                    {columns.map((col, i) => {
                                        if (i === 0 && el.hasOwnProperty("SELECTED")) {
                                            return (
                                                <td key={i} className="checkbox-td">
                                                    <Checkbox type="checkable"
                                                              name={index}
                                                              isSelected={el.SELECTED}
                                                              handleClick={() => toggleCheckbox({target: {name: index}})}
                                                    />
                                                </td>
                                            );
                                        }

                                        return (
                                            <td key={i}
                                                style={{textAlign: col.textAlign || "left"}}
                                                className="padding-left padding-right">
                                                {!col.subColumns && col.render(el)}
                                                {col.subColumns &&
                                                <div className='SortTable_subcols_body'>
                                                    {col.subColumns.map((subCol, j) => {
                                                        return (
                                                            <React.Fragment key={`${i}-${j}`}>
                                                                <div key={`${i}-${j}`}
                                                                     style={{textAlign: subCol.textAlign || "left"}}
                                                                     className={`flex ${j === 0 ? "padding-left" : ""}`}>
                                                                    {subCol.render(el)}
                                                                </div>
                                                                {j !== col.subColumns.length - 1 &&
                                                                <div className="border-right"/>}
                                                            </React.Fragment>
                                                        );
                                                    })}
                                                </div>
                                                }
                                            </td>
                                        );
                                    })}
                                </tr>
                            );
                        })
                        : null}
                    </tbody>
                </table>
            </React.Fragment>
        );
    }
}
